import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

interface SeoStyledListProps {
  items: string[];
  variant?: "check" | "bullet";
}

export const SeoStyledList = ({ items, variant = "check" }: SeoStyledListProps) => (
  <ul className="space-y-2.5 mt-2">
    {items.map((item, i) => (
      <motion.li
        key={i}
        initial={{ opacity: 0, x: -8 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.3, delay: i * 0.05 }}
        className="flex items-start gap-3 text-sm text-muted-foreground"
      >
        {variant === "check" ? (
          <CheckCircle2 className="w-4.5 h-4.5 text-brand-purple shrink-0 mt-0.5" />
        ) : (
          <span className="w-1.5 h-1.5 rounded-full bg-brand-purple shrink-0 mt-2" />
        )}
        <span>{item}</span>
      </motion.li>
    ))}
  </ul>
);
